import API from './axios.js';


// export const getCasesByName = (name, limit = 1000, page = 1) =>API.get(`case/by-name/${name}`, {params: { limit, page  }});
export const getCasesCourtRef = (courtref) =>API.get(`case/by-court-ref/${courtref}`);


export const getBothCourtCasesDetailsByCourtRef = (courtref) =>API.get(`case/all-courts/${courtref}`);


export const getCourtRef = () => API.get('case/by-name/nehul?limit=2')


export const getDistrictCasesByCourtRef = () => API.get('case/district-court/courtRef')
export const getHighCasesByCourtRef = () => API.get('case/high-court/courtRef')
export const getOtherCourtCasesAddedManuallyByCourtRef = () => API.get('case/other-court/courtRef')




export const gethcdatabycourtRef = (courtRef) => API.get(`scraper/hc-by-crn-no?crnno=${courtRef}`)
export const getdcdatabycourtRef = (courtRef) => API.get(`scraper/dc-by-crn-no?crnno=${courtRef}`)




export const getHighCourtCasesByCompany = () => API.get('case/by-company')
export const getHighCourtCasesAddedManually = () => API.get('case/manual')


export const getDistrictCourtCasesAddedManually = () => API.get('case/district-court/manual')
export const getDistrictCourtCasesByCompany = () => API.get('case/district-court/by-company')


export const getOtherCourtCasesAddedManually = () => API.get('case/other-court')


export const AddDistrictManualCases = () => API.post('case/district-court/manual')
export const AddHighManualCases = (payload) => API.post('case/manual',payload)




export const AddOtherCourtCases = (payload) => API.post('case/other-court',payload)


export const getOfficeReferenceByCourtRef = (courtref) =>API.get(`office-reference/court-ref/${courtref}`);
export const AddUpdateOfficeReference= (payload) => API.post('office-reference',payload)
export const DeleteOfficeReference= (id) => API.delete(`office-reference/${id}`)


export const getCaseAssignedByCompany = () => API.get('case-assignment/by-company')


export const getCompanyLimitedStats = () => API.get('company/limits')


export const DeleteHighCourtManualCaseByCourtRef= (courtRef) => API.delete(`case/manual?courtRef=${courtRef}`)
export const DeleteDistrictCourtManualCaseByCourtRef= (courtRef) => API.delete(`case/district-court/manual?courtRef=${courtRef}`)
export const DeleteOtherCourtManualCaseByCourtRef= (courtRef) => API.delete(`case/other-court/${courtRef}`)




export const UpdateHighManualCase= (courtRef,payload) => API.patch(`case/manual?courtRef=${courtRef}`,payload)
export const UpdateDistrictManualCase= (courtRef,payload) => API.patch(`case/district-court/manual?courtRef=${courtRef}`,payload)
export const UpdateOtherManualCase= (courtRef,payload) => API.patch(`case/other-court/${courtRef}`,payload)






export const UpdateHCFetchedManagedCases= (companyId,payload) => API.patch(`case/high-court/fetched-cases/selection/${companyId}`,payload)
export const UpdateHCAddedManagedCases= (companyId,payload) => API.patch(`case/high-court/added-cases/selection/${companyId}`,payload)
export const UpdateDCFetchedManagedCases= (companyId,payload) => API.patch(`case/district-court/fetched-cases/selection/${companyId}`,payload)
export const UpdateDCAddedManagedCases= (companyId,payload) => API.patch(`case/district-court/added-cases/selection/${companyId}`,payload)
export const UpdateOCAddedManagedCases= (companyId,payload) => API.patch(`case/other-court/added-cases/selection/${companyId}`,payload)


export const AddOrUpdateReAppealInCases = (payload) => API.post('re-appeal', payload)
export const GetReAppealedCasesByCompany = () => API.get('re-appeal/by-company')
export const GetReAppealedCasesByCourtRef = (courtRef) => API.get(`re-appeal/${courtRef}`)


export const AssignCasesInBulk = (payload) => API.post('case-assignment/bulk', payload)


// Updated to support query parameters for filtering and pagination


export const getIsCheckedHighCourtCasesByCompany = (queryParams = '') => API.get(`case/by-company/is-checked${queryParams}`)
export const getIsCheckedHighCourtCasesAddedManually = (queryParams = '') => API.get(`case/manual/is-checked${queryParams}`)
export const getIsCheckedDistrictCourtCasesAddedManually = (queryParams = '') => API.get(`case/district-court/manual/is-checked${queryParams}`)
export const getIsCheckedDistrictCourtCasesByCompany = (queryParams = '') => API.get(`case/district-court/by-company/is-checked${queryParams}`)
export const getIsCheckedOtherCourtCasesAddedManually = (queryParams = '') => API.get(`case/other-court/is-checked${queryParams}`)


// Case Assignment APIs
export const EditCaseAssignmentByCourtRef = (payload) => API.post('case-assignment/bulk', payload)
export const DeleteCaseAssignmentById = (assignmentId) => API.delete(`case-assignment/${assignmentId}`)

export const AddOrUpdateReAppeal = (payload) => API.post('re-appeal', payload)
export const DeleteReAppealById = (reAppealId) => API.delete(`re-appeal/${reAppealId}`)

// ManageCases APIs
// export const getDistrictCourtFetchedManageCases = (companyId) => API.get(`case/manage-cases/dc/fetched/${companyId}`)
// export const getHighCourtFetchedManageCases = (companyId) => API.get(`case/manage-cases/hc/fetched/${companyId}`)
// export const getOtherCourtAddedManageCases = (companyId) => API.get(`case/manage-cases/oc/added/${companyId}`)

// export const getDistrictCourtAddedManageCases = (companyId) => API.get(`case/manage-cases/dc/added/${companyId}`)
// export const getHighCourtAddedManageCases = (companyId) => API.get(`case/manage-cases/hc/added/${companyId}`)

export const getCompanyLimitedStatsById = (companyId) => API.get(`company/manage-cases/limits/${companyId}`)

export const getDistrictCourtFetchedManageCases = (companyId, queryParams = '') => API.get(`case/manage-cases/dc/fetched/${companyId}${queryParams}`)
export const getHighCourtFetchedManageCases = (companyId, queryParams = '') => API.get(`case/manage-cases/hc/fetched/${companyId}${queryParams}`)
export const getOtherCourtAddedManageCases = (companyId, queryParams = '') => API.get(`case/manage-cases/oc/added/${companyId}${queryParams}`)

export const getDistrictCourtAddedManageCases = (companyId, queryParams = '') => API.get(`case/manage-cases/dc/added/${companyId}${queryParams}`)
export const getHighCourtAddedManageCases = (companyId, queryParams = '') => API.get(`case/manage-cases/hc/added/${companyId}${queryParams}`)


export const AddCaseViaSpreadsheet = (payload) => API.post('case/add-cases-spreadsheet', payload)

// In CasesApi.js
export const uploadCasesSpreadsheet = (formData) => {
  return API.post("case/add-cases-spreadsheet", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    timeout: 60000, // 60 seconds timeout for large files
  });
};